export const defaultBankLogoSize = 28

export interface BankLogoProps {
	size?: number
	fill?: string
	className?: string
}
